import axios from 'axios';
import { useState } from 'react';
import { useNotify } from '@hotjar/hotsauce';

interface DownloadInvoiceProps {
  errorMessage: string;
}

interface DownloadInvoiceResponse {
  download: (link: string) => Promise<void>;
  isDownloading: boolean;
}

export function useDownloadInvoice({
  errorMessage,
}: DownloadInvoiceProps): DownloadInvoiceResponse {
  const [isDownloading, setIsDownloading] = useState(false);
  const { showToast } = useNotify();

  const download = async (url: string) => {
    setIsDownloading(true);
    try {
      const { data } = await axios.get(url, {
        responseType: 'blob',
      });

      const downloadUrl = window.URL.createObjectURL(data);
      window.open(downloadUrl, '__blank');
      window.URL.revokeObjectURL(url);
    } catch {
      showToast({
        kind: 'danger',
        text: errorMessage,
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    download,
    isDownloading,
  };
}
